const VERSION = "16.1.2";
export {
  VERSION
};
